'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'sparkles';
var width = 512;
var height = 512;
var aliases = [10024];
var unicode = 'f890';
var svgPathData = ['M16 254.6l114.1 52.7c3.5 1.6 6.2 4.4 7.8 7.8l52.7 114.1L243.2 315c1.6-3.5 4.4-6.2 7.8-7.8l114.1-52.7L251 201.9c-3.5-1.6-6.2-4.4-7.8-7.8L190.6 80 137.9 194.1c-1.6 3.5-4.4 6.2-7.8 7.8L16 254.6z', 'M432 40c4.4 0 8 3.6 8 8l0 56 56 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-56 0 0 56c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-56-56 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l56 0 0-56c0-4.4 3.6-8 8-8zm0 288c4.4 0 8 3.6 8 8l0 56 56 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-56 0 0 56c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-56-56 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l56 0 0-56c0-4.4 3.6-8 8-8zM130.1 201.9L16 254.6l114.1 52.7c3.5 1.6 6.2 4.4 7.8 7.8l52.7 114.1L243.2 315c1.6-3.5 4.4-6.2 7.8-7.8l114.1-52.7L251 201.9c-3.5-1.6-6.2-4.4-7.8-7.8L190.6 80 137.9 194.1c-1.6 3.5-4.4 6.2-7.8 7.8zm-6.7 119.9L9.3 269.1C3.6 266.5 0 260.8 0 254.6s3.6-11.9 9.3-14.5l114.1-52.7L176 73.3c2.6-5.7 8.3-9.3 14.5-9.3s11.9 3.6 14.5 9.3l52.7 114.1L371.8 240c5.7 2.6 9.3 8.3 9.3 14.5s-3.6 11.9-9.3 14.5L257.8 321.8 205.1 435.8c-2.6 5.7-8.3 9.3-14.5 9.3s-11.9-3.6-14.5-9.3L123.4 321.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;